import { ApplicationMuiTheme } from 'Lib/themes/muiTheme';

import authServiceMap from './auth/authServiceMap';
import { LoginMethodType } from './constant';

export const getLoginMethod = async (isAdmin: boolean, muiTheme: ApplicationMuiTheme) => {
    const loginMethod: string = muiTheme?.app?.clientTheme.features.Authentication.LoginMethod;

    switch (loginMethod) {
        case LoginMethodType.HOSTED_KEYCLOAK: {
            const authService = await authServiceMap[loginMethod]();
            authService.login(isAdmin);

            return null;
        }
        default:
            console.error(`AuthService not found for login method: ${loginMethod}`);

            return null;
    }
};